import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {removeNotification} from "../../actions/notifications-actions";

class Notifications extends React.Component {
    render() {
        return (
            <div className='container'>
                {
                    this.props
                        .notifications
                        .list
                        .map((notification, index) => {
                            return (
                                <div key={notification.id} className={'alert alert-dismissible alert-' + notification.type}>
                                    {notification.text}
                                    <button type="button" className="close" onClick={() => this.props.removeNotification(notification.id)}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            )
                    })
                }
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        notifications: state.notifications
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        removeNotification: removeNotification,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Notifications);
